import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';

import { useFormularioContext } from '../../commons/Formulario';

import Boton from '../../commons/Boton';
import CheckBox from '../../commons/CheckBox';
import Combo from '../../commons/Combo';
import GroupText from '../../commons/GroupText';
import MaterialCommunityIcons from '../../commons/Icons/MaterialCommunityIcons';
import Loading from '../../commons/Loading';
import TextArea from '../../commons/TextArea';

import useMantenimiento from '../../hooks/useMantenimiento';

import { confirmacion, mensaje, mensajeMini } from '../../commons/Mensajes';
import { formatoFecha } from '../../commons/Utilitarios';

const MaintenanceSave = ({ equipment, previusEquipment, onSave }) => {
  const { selected, accionTask } = useFormularioContext();
  const { postMaintenance } = useMantenimiento();
  const { tipoMantenimiento } = useSelector((state) => state.detalle);

  const [maintenance, setMaintenance] = useState({
    tm: tipoMantenimiento.find((x) => x.de === previusEquipment?.dt)?.dt,
    sr: previusEquipment?.sr,
    dt: previusEquipment?.dm,
    rc: previusEquipment?.rc,
  });
  const [process, setProcess] = useState(false);
  const [fieldsErrors, setFieldsErrors] = useState(null);

  const handleChange = (item) => {
    const { name, value } = item;
    setMaintenance((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveMaintenance = async () => {
    setProcess(true);
    let response = await postMaintenance({
      so: selected.so,
      ia: accionTask,
      dt: [
        {
          eq: equipment.eq.eq,
          tm: maintenance.tm,
          sr: maintenance.sr,
          dt: maintenance.dt,
          rc: maintenance.rc,
        },
      ],
    });
    if (response.success && response.status === 'success') {
      mensaje('Operación Satisfactoria');
      onSave(response.result);
    } else if (response.messageError) {
      mensajeMini(response.messageError);
    } else {
      setFieldsErrors(response.fieldsErrors);
    }
    setProcess(false);
  };

  return (
    <div className="op-form">
      {process && <Loading tipo={'request'} />}
      {previusEquipment?.fa ? (
        <div>
          <GroupText
            text={formatoFecha(previusEquipment.fa)}
            label={previusEquipment.dt}
            icon={
              <MaterialCommunityIcons
                name="calendar-check-outline"
                color="#374a72"
                size={25}
              />
            }
          />
          <GroupText
            text={'Técnico'}
            label={previusEquipment.nt}
            icon={
              <MaterialCommunityIcons
                name="account-hard-hat"
                color="#de281f"
                size={25}
              />
            }
          />
          <GroupText
            text={'Mantenimiento'}
            label={previusEquipment.dm}
            icon={
              <MaterialCommunityIcons
                name="text-long"
                color="#374a72"
                size={25}
              />
            }
          />
          <GroupText
            text={'Recomendaciones y/o observaciones'}
            label={previusEquipment.rc}
            icon={
              <MaterialCommunityIcons
                name="text-long"
                color="#374a72"
                size={25}
              />
            }
          />
        </div>
      ) : (
        <>
          <Combo
            label="Tipo Mantenimiento"
            name="tm"
            size={2}
            tabIndex={10}
            value={maintenance.tm}
            data={tipoMantenimiento.map((x) => ({
              value: x.dt,
              label: x.de,
            }))}
            onChange={handleChange}
            error={fieldsErrors?.['dt.tm']}
          />
          <div className="op-form-group op-col-2 op-checkbox-group">
            <span>¿Es reparaci&oacute;n?</span>
            <CheckBox
              name="sr"
              tabIndex={11}
              checked={maintenance.sr}
              onChange={handleChange}
            />
          </div>
          <TextArea
            label="Mantenimiento"
            name={'dt'}
            tabIndex={12}
            value={maintenance.dt}
            onChange={handleChange}
            error={fieldsErrors?.['dt.dt']}
          />
          <TextArea
            label="Recomendaciones"
            name={'rc'}
            tabIndex={12}
            value={maintenance.rc}
            onChange={handleChange}
            error={fieldsErrors?.['dt.rc']}
          />
          <div className="op-form-group">
            <Boton
              className="op-grabar"
              icon={() => <SaveIcon />}
              onClick={() =>
                confirmacion(
                  '¿Está seguro?',
                  `De registrar el mantenimiento del equipo ${equipment.eq.ne}, recuerde que ya no podra volver a enviar esta información`
                )
                  .then(() => handleSaveMaintenance())
                  .catch(() => {})
              }
            >
              Registrar Mantenimiento
            </Boton>
          </div>
        </>
      )}
    </div>
  );
};

MaintenanceSave.propTypes = {
  equipment: PropTypes.object,
  previusEquipment: PropTypes.object,
  onSave: PropTypes.func,
};

export default MaintenanceSave;
